import { Box, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { GetPendingRequest, GetPendingSCN, GetPendingSRA, GetPendingTransfer } from '../Utils/ApiCalls'
import MorePendingSRA from './MorePendingSra';
import MoreSRA from './MoreSRA';
import PendingIQA from './PendingIQA';
import ScnDetails from './ScnDetails';
import TableRow from './TableRow'
import UpdateQty from './UpdateQty';
import RejectAction from './RejectAction';

import ApproveAction from './ApproveAction';

import { configuration } from '../Utils/config';
import Pagination from './Pagination';
import SearchComponent from './SearchComponent';

export default function TransferTechApproval() {

    const [Data, setData] = useState([]);
    const [SraID, setSraID] = useState("");
    const [Id, setId] = useState("");
    const [HandleMoreSRA, setHandleMoreSRA] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [OpenModal, setOpenModal] = useState(false);
    const [OpenApprovalModal, setOpenApprovalModal] = useState(false);
    const [SingleData, setSingleData] = useState([]);

    const [SearchText, setSearchText] = useState("");

    //get current post

    const [CurrentPage, setCurrentPage] = useState(1);
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentData = Data?.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }




    const AllSRA = async () => {
        let result = await GetPendingTransfer()

        console.log("object pending transfer", result);

        if (result.status == true) {
            setData(result.queryresult)
        }
    }

    const editQty = (id) => {

        let singleInfo = Data.filter((item, i) => {
          return item._id === id
        })
        setOpenModal(true)
        setSingleData(singleInfo)
      }




      const openRejection = (id)=>{
        onOpen()
        setId(id)
      }
      const openApprove = (id) => {
        setOpenApprovalModal(true);
        setId(id);
        
        
      }

    useEffect(() => {

        AllSRA()

        
    }, [isOpen,OpenModal,OpenApprovalModal]);


    return (
     <Box>
                  <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"Name, shelfId, Requester'sEmail"} />

           <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>

<Text p="10px" textTransform="Capitalize" color="#fff" display={"flex"} justifyContent="flex-end">Total Pending Approval - {Data.length}</Text>

<TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

>
    <Table variant='simple' size='sm' overflowX="auto" >
        <Thead>
            <Tr>
                <Th color="#fff">S/N</Th>
                <Th color="#fff">Name</Th>
                <Th color="#fff">Shelf id</Th>
                <Th color="#fff">S-Store</Th>
                <Th color="#fff">R-Store</Th>
                <Th color="#fff">Qty</Th>
                <Th color="#fff">Requesters's Email</Th>
                <Th color="#fff">Status</Th>
                <Th color="#fff">Rejection</Th>

                <Th color="#fff">Approve</Th>

              

            </Tr>
        </Thead>
        <Tbody>

            {
                SearchText === "" ? (
                    currentData?.map((item, i) => (
                    <TableRow
                        key={i}
                        sn={i + 1}
                        type="TransferApprovalT"
                        productName={item.productname}
                        productShelfId={item.productcode}
                        store={item.sendingstore}
                        storeName={item.receivingstore}
                        qty={item.qtytotransfer}
                        email={item.requesteremail}
                        status={item.status}
                        Approve={() => openApprove(item._id)}

                        Reject={() => openRejection(item._id)}

                        onClick={() => editQty(item._id)}

                       
                       
                    />
                ))
                ):(
                    SearchText !== "" && currentData.filter(item => item.productcode?.toLowerCase().includes(SearchText) || item.requesteremail?.toLowerCase().includes(SearchText) || item.productname?.toLowerCase().includes(SearchText)).length > 0 ? (
                    currentData.filter(item => item.productcode?.toLowerCase().includes(SearchText) || item.requesteremail?.toLowerCase().includes(SearchText) || item.productname?.toLowerCase().includes(SearchText)).
                        map((item, i) => (
                    <TableRow
                        key={i}
                        sn={i + 1}
                        type="TransferApprovalT"
                        productName={item.productname}
                        productShelfId={item.productcode}
                        store={item.sendingstore}
                        storeName={item.receivingstore}
                        qty={item.qtytotransfer}
                        email={item.requesteremail}
                        Approve={() => openApprove(item._id)}
                        onClick={() => editQty(item._id)}

                       
                       
                    />
                ))
                    ):(
                        <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>
                    )

                
                )
              
            }


        </Tbody>

    </Table>
</TableContainer>
<Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data?.length} paginate={paginate} />

{/* this is for the approval modal that receive the type of approval*/}

<RejectAction isOpen={isOpen} onClose={onClose} id={Id} state="ApproveTransfer"/>

<ApproveAction isOpen={OpenApprovalModal} onClose={()=>setOpenApprovalModal(false)} id={Id} state="ApprovalTransfer"/>

<UpdateQty SingleData={SingleData} state="transfer" isOpen={OpenModal} onClose={()=>setOpenModal(false)} id={Id}/>



</Box>
     </Box>
    )
}
